import { baseNotificationsReducer } from '../base-notification/base-notification.reducer';
import { DocumentNotificationsState, initialState } from '../document-notifications.state';
import {
    LoadCertificationNotificationsSuccess, LoadPublicHealthRecordNotificationsSuccess,
    SetCertificationNotificationAsReadSuccess, SetPublicHealthRecordNotificationAsReadSuccess
} from './document-notifications.actions';

export function documentNotificationsReducer(state = initialState, action: any): DocumentNotificationsState {

    if (action instanceof LoadCertificationNotificationsSuccess || action instanceof SetCertificationNotificationAsReadSuccess) {
        return {
            ...state,
            certifications: baseNotificationsReducer(state.certifications, action)
        };
    }
    else if (action instanceof LoadPublicHealthRecordNotificationsSuccess
        || action instanceof SetPublicHealthRecordNotificationAsReadSuccess) {
        return {
            ...state,
            publicHealthRecords: baseNotificationsReducer(state.publicHealthRecords, action)
        };
    }
    else {
        return state;
    }
}
